module.exports = __webpack_public_path__ + "img/wordpress.fa6246e6.png";